import {Banner} from '@wandb/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import doc_urls from '../util/doc_urls';

export const WeRecommendAlertAutomations = () => {
  return (
    <Tailwind>
      <div className="mb-16">
        <Banner variant="warning" isDismissible={false}>
          <Banner.Body>
            <span className="font-semibold">
              We recommend alert automations.
            </span>{' '}
            Project automations now offer new trigger events including 'Run
            status change'. Also find per-automation Slack channel selection.
          </Banner.Body>
          <Banner.Action href={doc_urls.automation} target="_blank">
            Learn more
          </Banner.Action>
        </Banner>
      </div>
    </Tailwind>
  );
};
